import * as WebsocketActions from './websocket.reducer'

export const { createWebsocketConnection } = WebsocketActions
